import DashboardHeader from '../shared/components/DashboardHeader';
import SideMenu from '../shared/components/SideMenu';
import Footer from '../shared/components/Footer';
import React, { useState, useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import HttpCall from '../api/Http';
import User from '../shared/Utils/User';
import { useSearchParams } from "react-router-dom";
import SerializeClass from '../shared/Utils/serialized';

export default function Plans() {

    const stripePromise = loadStripe('pk_live_51LnRHvGzrU0sb1NUtDLu8I3i5QnAXUBx0bE5LyId2eNvh6BRqbcFqTIvyw2BztgYPWJ38eVDkHxALFnl5GpyWTRS00a1FOM54m');
    // const stripePromise = loadStripe('pk_test_51LnRHvGzrU0sb1NUDSaCiFTbeCSdbZVY3tHByedtfBTfyh3hsofwISiKPJxNplc0S9pG4ovgVzyEB4t7zC1RjjFz000PceCfRn');
    const user = User.getUser()
    let [message, setMessage] = useState('');
    const [showCheckout, setShowCheckout] = useState(false);
    const [isRun, setIsRun] = useState(false);
    let [success, setSuccess] = useState(false);
    let [error, setError] = useState(false);
    let [paymentIntentId, setPaymentIntentId] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    let [options = {
        // passing the client secret obtained from the server
        clientSecret: '',
    }, setOptions] = useState(false);
    let customerId = "";

    useEffect(() => {
        if (isRun) { return; }
        setPaymentIntentId(searchParams.get("payment_intent"))
        if (paymentIntentId != null && paymentIntentId != "") {

            let arr = [];
            arr.push({ P_payment_intent_id: paymentIntentId });
            arr.push({ P_user_id: user[0].Id });

            if (searchParams.get("redirect_status") == "succeeded") {
                arr.push({ P_payment_status_id: 2 });
                arr.push({ P_response_comment: searchParams.get("redirect_status") });
                setSuccess(true);
                setIsRun(true)
            }
            else {
                arr.push({ P_payment_status_id: 3 });
                arr.push({ P_response_comment: searchParams.get("redirect_status") });
                setMessage('Payment request failed');
                setError(true);
                setIsRun(true)
            }

            let requestData = new FormData();
            let p = SerializeClass.getSerializedData(arr);
            requestData.append('Params', p);
            let url = `/api/Payment/updatePaymentStatus`;
            HttpCall.postRequest2(url, requestData).then(response => {

            })

        }
    })

    const CheckoutForm = () => {
        const stripe = useStripe();
        const elements = useElements();

        const handleSubmit = async (event) => {
            // We don't want to let default form submission happen here,
            // which would refresh the page.
            event.preventDefault();

            if (!stripe || !elements) {
                // Stripe.js has not yet loaded.
                // Make sure to disable form submission until Stripe.js has loaded.
                return;
            }

            const result = await stripe.confirmPayment({
                //`Elements` instance that was used to create the Payment Element
                elements,
                confirmParams: {
                    return_url: "https://dashboard.getbound.ai/plans",
                },
            });


            if (result.error) {
                // Show error to your customer (for example, payment details incomplete)
                setMessage(result.error.message);
                setError(true);
                setIsRun(true);
            } else {
                // Your customer will be redirected to your `return_url`. For some payment
                // methods like iDEAL, your customer will be redirected to an intermediate
                // site first to authorize the payment, then redirected to the `return_url`.
            }
        };

        return (
            <form onSubmit={handleSubmit}>
                <PaymentElement />
                <button className='btn btn-primary me-2 savebtn' disabled={!stripe}>Submit</button>
            </form>
        )
    };

    const paymentInit = (e, priceId) => {
        e.preventDefault();

        let requestData = new FormData();
        requestData.append('UserId', user[0].Id);
        requestData.append('Email', user[0].Email);
        requestData.append('UserName', user[0].User_Name);

        let url = `/api/Payment/register-customer`;
        HttpCall.postRequest(url, requestData).then(response => {
            customerId = response.data;
            requestData = new FormData();
            requestData.append('customerId', customerId);
            requestData.append('priceId', priceId);
            requestData.append('userId', user[0].Id);

            url = `/api/Payment/create-subscription`;
            HttpCall.postRequest(url, requestData).then(response => {
                let option = {
                    // passing the client secret obtained from the server
                    clientSecret: response.data.clientSecret,
                }
                setOptions(option)
                setShowCheckout(true);
            });
        });
    }

    function closePopup(e) {
        e.preventDefault();
        setSuccess(false);
        setError(false);
    }


    return (
        <>
            <DashboardHeader />
            <div className="container-fluid page-body-wrapper">
                <SideMenu />
                <div className="main-panel">
                    <div className="content-wrapper">

                        {success && <div id="SuccessfullyModal" className="modal" style={{ display: 'block' }}>
                            <div className="modal-content">
                                <span className="close3 closebtn">&times;</span>
                                <i className="mdi mdi-checkbox-marked-circle-outline"></i>
                                <h1>Payment Successfull!</h1>
                                <button type="button" className="btn btn-primary btn-rounded btn-md" onClick={closePopup}>OK</button>
                            </div>
                        </div>}

                        {error && <div id="SuccessfullyModal" className="modal" style={{ display: 'block' }}>
                            <div className="modal-content">
                                <span className="close3 closebtn">&times;</span>
                                <i className="mdi mdi-alert-circle-outline"></i>
                                <h1>{message}</h1>
                                <button type="button" className="btn btn-primary btn-rounded btn-md" onClick={closePopup}>OK</button>
                            </div>
                        </div>}

                        {showCheckout && <Elements stripe={stripePromise} options={options}>
                            <CheckoutForm />
                        </Elements>
                        }

                        {!showCheckout && <div className="row">

                            <div className="col-md-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title text-center">Want to upgrade your account?</h4>
                                        <p className="card-description text-center">
                                            You are currently enjoying the <b>{user[0].plan_name}</b>.<br /> On <b>{user[0].end_date}</b> your plan will be renewed
                                        </p>




                                        <div className="row">

                                            <div className="col-md-4 card ">
                                                <div className="card-body custompricingheight">
                                                    <h2 className="card-title text-center">Free + Basic Plan</h2>
                                                    <div className="card-subtitle text-center">Perfect for Startups<br />and it includes:</div>
                                                    <hr className="cell-divide-hr" />
                                                    <div className="price text-center">
                                                        <span className="currency">$</span><span className="value">500</span>
                                                        <div className="frequency">monthly</div>
                                                    </div>
                                                    <hr className="cell-divide-hr" />
                                                    <ul className="list-unstyled li-space-lg">
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">Trigger-Based Messaging Sequence Service</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">You can run up to 1 sequence at a time</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">Outbound with LinkedIn, Emails, Twitter</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body"> Provision to Create/ Upload your own Lead List</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">You can use 30 contacts (via Lead List) with a free one-month trial.</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">After trail, can use 60 contacts (via Lead List)</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">Provision to maintain Opportunities</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">Provision to maintain Accounts</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check  "></i><div className="media-body">Dashboard Reports</div>
                                                        </li>
                                                    </ul>
                                                    <div className="button-wrapper">
                                                        {/* <a className="btn-solid-reg page-scroll changeCursor" onClick={e => { paymentInit(e, 'price_1M17QFGzrU0sb1NUMB4mdgqk') }}>Select</a> */}
                                                        <a className={user[0].plan_id == 1 || user[0].plan_id == 4 ? "btn-solid-reg-selected page-scroll changeCursor" : "btn-solid-reg page-scroll changeCursor"} onClick={e =>  user[0].plan_id == 1 || user[0].plan_id == 4 ? undefined : paymentInit(e, 'price_1MSp8DGzrU0sb1NU44SMgBjX') }>{user[0].plan_id == 1 || user[0].plan_id == 4 ? "Selected" : "Select"}</a>
                                                    </div>
                                                </div>
                                            </div>



                                            <div className="col-md-4 card ">
                                                <div className="card-body custompricingheight">
                                                    <h2 className="card-title text-center">Standard Plan</h2>
                                                    <div className="card-subtitle text-center">Works perfect for SMEs and the package includes:</div>
                                                    <hr className="cell-divide-hr" />
                                                    <div className="price text-center">
                                                        <span className="currency">$</span><span className="value">1500</span>
                                                        <div className="frequency">monthly</div>
                                                    </div>
                                                    <hr className="cell-divide-hr" />
                                                    <ul className="list-unstyled li-space-lg">
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">Trigger-Based Messaging Sequence Service</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">Can run up to 4 separate sequences simultaneouslyfor different market segments/personas</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">Outbound with LinkedIn, Emails, Twitter</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">Provision to maintain Opportunities</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">Provision to maintain Accounts</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">Provision to Create/ Upload Multiple Lead Lists</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body"> Support “60 contacts” with each sequence</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">CRM Integration</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">Dashboard Reports</div>
                                                        </li>
                                                    </ul>
                                                    <div className="button-wrapper">
                                                        <a className={user[0].plan_id == 2 ? "btn-solid-reg-selected page-scroll changeCursor" : "btn-solid-reg page-scroll changeCursor"} onClick={e =>  user[0].plan_id == 2 ? undefined : paymentInit(e, 'price_1MSp9UGzrU0sb1NULH0tRPeh') }>{user[0].plan_id == 2 ? "Selected" : "Select"}</a>
                                                    </div>
                                                </div>
                                            </div>



                                            <div className="col-md-4 card ">


                                                <div className="card-body custompricingheight">
                                                    <h2 className="card-title text-center">Custom Plan</h2>
                                                    <div className="card-subtitle text-center">Works perfect for the corporate sector and in this package</div>
                                                    <hr className="cell-divide-hr" />
                                                    <div className="price text-center">
                                                        <br />
                                                        <span className="currency"><b className="font40">Talk to us</b></span>
                                                    </div>
                                                    <hr className="cell-divide-hr" />
                                                    <ul className="list-unstyled li-space-lg">
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body"> We offer customized outreach services especially designed to meet the goals of your business.</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body"> From developing to implementing the outreachstrategy, we have got you covered.</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">We will provide the sequence + email lead list and runmultiple sequences on multiple platforms for your business on your behalf.</div>
                                                        </li>
                                                        <li className="media">
                                                            <i className="mdi mdi-check"></i><div className="media-body">Conduct integratoins and setup customized CRMs for your support and much more</div>
                                                        </li>
                                                    </ul>
                                                    <div className="button-wrapper">
                                                        <a className="btn-solid-reg page-scroll changeCursor">{user[0].plan_id == 3 ? "Selected" : "Select"}</a>
                                                    </div>
                                                </div>

                                            </div>


                                        </div>



                                        <br />
                                        <br />
                                        <br />



                                    </div>
                                </div>
                            </div>






                        </div>}
                    </div>

                    <footer className="footer">
                        <div className="d-sm-flex justify-content-center justify-content-sm-between">

                            <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Copyright © 2023 <a href="http://getbound.ai/">Getbound.ai</a> - All rights reserved</span>
                        </div>
                    </footer>

                </div>


            </div>
        </>
    )
}
